import { CLUB_STATS } from "../data/clubStats";
import { StatCard } from "./StatCard";

const ROUTE_TOP_MOBILE = "/assets/pack-zero-franchise/route_top_mobile.svg";
const ROUTE_TOP_TABLET = "/assets/pack-zero-franchise/route_top_tablet.svg";
const ROUTE_TOP_DESKTOP = "/assets/pack-zero-franchise/route_top_desktop.svg";
const ROUTE_BOTTOM_MOBILE = "/assets/pack-zero-franchise/route_bottom_mobile.svg";
const ROUTE_BOTTOM_TABLET = "/assets/pack-zero-franchise/route_bottom_tablet.svg";
const ROUTE_BOTTOM_DESKTOP = "/assets/pack-zero-franchise/route_bottom_desktop.svg";

export const ClubStatsSection = () => {
  return (
    <section
      className={[
        "relative flex flex-col items-center overflow-hidden bg-[#FFD100] text-center",
        "gap-10 px-4 py-[120px]",
        "md:px-10",
        "xl:gap-16 xl:px-0",
        "2xl:mx-auto 2xl:max-w-[1600px]",
      ].join(" ")}
    >
      <RouteDecorations />

      <div className="relative z-10 flex max-w-[344px] flex-col items-center gap-3 md:max-w-[502px]">
        <h2 className="text-[23px] font-bold leading-[1.2] text-[#0D0D0D] md:text-[28px]">
          Rejoignez le plus grand club automobile en France
        </h2>
        <p className="text-[16px] leading-[1.6] text-[#0D0D0D]">Quelques chiffres</p>
      </div>

      <div
        className={[
          "relative z-10 flex w-full flex-wrap items-start justify-center",
          "max-w-[344px] gap-x-8 gap-y-8",
          "md:max-w-[512px] md:gap-x-0",
          "xl:max-w-none xl:flex-nowrap xl:gap-x-[88px]",
        ].join(" ")}
      >
        {CLUB_STATS.map((stat) => (
          <StatCard key={stat.id} stat={stat} />
        ))}
      </div>
    </section>
  );
};

const RouteDecorations = () => (
  <>
    <img
      aria-hidden
      src={ROUTE_TOP_MOBILE}
      alt=""
      className="pointer-events-none absolute right-0 top-0 block md:hidden"
    />
    <img
      aria-hidden
      src={ROUTE_TOP_TABLET}
      alt=""
      className="pointer-events-none absolute right-0 top-0 hidden md:block xl:hidden"
    />
    <img
      aria-hidden
      src={ROUTE_TOP_DESKTOP}
      alt=""
      className="pointer-events-none absolute right-0 top-0 hidden xl:block"
    />

    <img
      aria-hidden
      src={ROUTE_BOTTOM_MOBILE}
      alt=""
      className="pointer-events-none absolute bottom-0 left-0 block md:hidden"
    />
    <img
      aria-hidden
      src={ROUTE_BOTTOM_TABLET}
      alt=""
      className="pointer-events-none absolute bottom-0 left-0 hidden md:block xl:hidden"
    />
    <img
      aria-hidden
      src={ROUTE_BOTTOM_DESKTOP}
      alt=""
      className="pointer-events-none absolute bottom-0 left-0 hidden xl:block"
    />
  </>
);
